var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-container"},[_c('ul',{staticClass:"primary--text"},_vm._l((_vm.menus),function(menu,index){return _c('li',{key:index},[_vm._v(_vm._s(menu.name))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }